import React from 'react';

import RichTextEditorContent from '../../RichTextEditor/components/RichTextEditorContent';

import styles from './PostRichTextEditor.module.scss';

const postClassNames = {
  container: styles.postEditorContainer,
  paragraph: styles.paragraph,
  citation: styles.citation,
};

const PostRichTextEditor = ({
  setState,
  state,
  contentEditable,
}) => {
  return (
    <RichTextEditorContent
      state={state}
      setState={setState}
      contentEditable={contentEditable}
      classNames={postClassNames}
    />
  );
};

export default PostRichTextEditor;
